import React from 'react';
import { Center, Icon, VStack } from '@wegroup/design-system';
import { useTranslation } from 'react-i18next';
import { format } from 'date-fns';
import LabeledParam from '../../../../../../common/src/components/LabeledParam';

// Types
import { Accident } from '../../../../../../../types/ProductFactory';

interface Props {
  accident: Accident;
  onClick: () => void;
}

const AccidentDisplay: React.FC<React.PropsWithChildren<Props>> = ({
  accident,
  onClick,
}) => {
  const { t } = useTranslation();

  return (
    <VStack onClick={onClick} w="100%" h="100%" align="stretch" spacing="3">
      <Center alignSelf="flex-start" bg="primary.100" borderRadius="full" p="2">
        <Icon name="RiskObjectsVehicleAccident" color="primary.500" />
      </Center>
      <LabeledParam label={t('Date')}>
        {format(new Date(accident?.date || ''), 'dd/MM/yyyy')}
      </LabeledParam>
      <LabeledParam label={t('ACCIDENT_LIABILITY_TITLE')}>
        {t(`ACCIDENT_TYPE_${accident.liability}`)}
      </LabeledParam>
      {accident.type && (
        <LabeledParam label={t('Type')}>
          {t(`ACCIDENT_LIABILITY_${accident.type}`)}
        </LabeledParam>
      )}
    </VStack>
  );
};

export default AccidentDisplay;
